import React, { Component } from 'react';
import { Tag } from 'antd';
import Label from './label';
const CheckableTag = Tag.CheckableTag;

export default class TagRefer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bIsNull: props.bIsNull,
      visible: !props.bHidden,
    };
    this.onClick();
    this.allText = '全部';
  }
  onClick = () => {
    let { model } = this.props;
    if (model && model.browse)
      model.browse(true);
  }
  componentDidMount() {
    if (this.props.model)
      this.props.model.addListener(this);
  }
  componentDidUpdate() {
    if (this.props.model)
      this.props.model.addListener(this);
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
  }
  open = (e) => {
    this.referViewModel = e.vm;
    this.gridModel = e.vm.get('table');
    this.gridModel.addListener(this);
  }
  setDataSource = (dataSource) => {
    if (this.state.needAll !== false && dataSource && dataSource.length) {
      const allItem = {};
      allItem[this.state.textField] = this.allText;
      dataSource.splice(0, 0, allItem);
    }
    this.setState({ dataSource });
    if (!dataSource.length) return;
    this.state.dataSource = dataSource;
    this.onChange(this.state.value || dataSource[0][this.state.textField]);
  }
  setValue = (value) => {
    this.setState({ value });
  }
  onChange = (value) => {
    const { textField } = this.state;
    let index = this.state.dataSource.findIndex(item => {
      return item[textField] === value;
    });
    if (this.state.needAll !== false)
      index--;
    let referValue;
    if (value === this.allText) {
      const allItem = {};
      allItem[textField] = value;
      referValue = [allItem];
    } else {
      this.gridModel.select([index]);
      referValue = this.gridModel.getSelectedRows();
    }
    this.referViewModel.execute('afterOkClick', referValue);
  }
  baseControl = () => {
    const { dataSource, valueField, textField } = this.state;
    if (!dataSource || !dataSource.length)
      return null;
    let CheckableTagList = [];
    dataSource.forEach(item => {
      const value = item[valueField], text = item[textField];
      const checked = text === (this.state.value || this.allText);
      CheckableTagList.push(
        <CheckableTag
          key={value}
          checked={checked}
          onChange={() => this.onChange(text)}>
          {text}
        </CheckableTag>
      )
    });
    return (
      <div className="tag-group">
        {CheckableTagList}
      </div>
    );
  }
  getControl() {
    const { cShowCaption } = this.props;
    const title = !this.state.readOnly && this.state.bIsNull === false && cShowCaption ? <label><Icon type='star' />{cShowCaption}</label> : <label>{cShowCaption}</label>;
    let control = (cShowCaption ? <Label control={this.baseControl()} title={title} /> : this.baseControl());
    return control;
  }
  render() {
    const control = this.getControl();
    let style = this.state.visible ? {} : { display: "none" };
    let errClass = `basic-tag-refer has-feedback ${this.state.classname || ''} ` + this.state.err;
    return (
      <div style={style} className={errClass}>
        {control}
        <div className="ant-form-explain">{this.state.msg}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/tagrefer.jsx